/**
 * Created by dv on 7/11/2017.
 */
import {
  EditZmCollectionMessage,
  EditZmCollectionQuery,
  ZmCollection,
  SimpleResponse
} from "../../../autogenerated/ZoomBridge";

import { Logger } from './../../../logger/Logger';


export default class EditCollection {
  /**
   *
   * @param collectionId{number}
   */
  constructor(collectionId) {
    /**
     * @private
     * @type {Logger}
     * @const
     */
    this.logger = new Logger("EditCollection");

    /**
     * @private
     * @type {ZmCollection}
     */
    this.collection = new ZmCollection();
    if (collectionId > 0) {
      this.collection.setCollectionId(collectionId);
    } else {
      throw new Error("Collection id can't be less than or equal to zero.")
    }
    /**
     * @private
     * @type {number}
     */
    this.moveFromParentId = 0;
  }

  /**
   * Updates the collection name
   * @param name{String}
   * @return {EditCollection}
   * @public
   */
  setName(name) {
    if (this.collection) {
      this.collection.setName(name);
    }
    return this;
  }

  /**
   * Updates the collection's parent id'
   * @param parentId {number}
   * @return {EditCollection}
   * @public
   */
  setParentId(parentId) {
    if (this.collection) {
      this.collection.setParentId(parentId);
    }
    return this;
  }

  /**
   * Updates the collection's bin
   * @param bin {boolean}
   * @public
   */
  setBin(bin) {
    if (this.collection) {
      this.collection.setBin(bin);
    }
    return this;
  }

  /**
   * Sets the collection's existing parent id
   * @param parentId {number}
   * @return {EditCollection}
   * @public
   */
  setMoveFromParentId(parentId) {
    if (this.collection) {
      this.moveFromParentId = parentId;
    }
    return this;
  }

  /**
   * resp{SimpleResponse} will be used as input to onSuccess
   * @return {Promise.<Boolean,ErrorId>}
   */
  run() {
    let editZmCollectionMessage = new EditZmCollectionMessage();
    editZmCollectionMessage.setZmCollection(this.collection);
    editZmCollectionMessage.setMoveFromParentId(this.moveFromParentId);
    /**
     * @type {EditZmCollectionQuery}
     */
    const query = new EditZmCollectionQuery();
    query.message = editZmCollectionMessage;
    return query.run(true);
  }
}
